<template>
    <div >
      <portlet :clase="'container col-md-12 blockui_sample_3_2_element'" > 
        <template slot="actions">
            <a class="btn btn-circle btn-icon-only btn-success" :href="link_download" data-toggle='modal' title='Descargar Excel' ><i class="fa fa-file-excel-o"></i></a>
            <a class="btn btn-circle btn-icon-only btn-default" href="#portlet-edit" data-toggle='modal' title='Agregar registro' v-on:click="nuevoRegistro()"><i class="fa fa-plus"></i></a>          
        </template>
        <template slot="caption">
          <div class="row"> 
            <div class='col-md-6'>          
                <span class="caption-subject bold uppercase"> 
                    <i class="fa fa-database"></i> Administracion de base de datos 
                    &nbsp;<a class="btn btn-circle btn-icon-only btn-default" title='Recargar registros' v-on:click="loadTableSample()"><i class="fa fa-rotate-left"></i></a>
                </span>         
            </div>      
          </div>  
        </template>      
        <template slot="body">         
          <div class="row">           
            <tableSample :lengthMenu="lengthMenu" @detalle="editarRegistro" @eliminar="editarRegistro"  :data_="data_" :id="'sample_2'" v-if="renderTable"/>  
          </div>
        </template>
      </portlet>
     
      <modal :id="'portlet-edit'" :modal="'modal-lg'">      
        <template slot="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" v-on:click="limpiarInputs()"></button>
            <h4 class="modal-title"><i class="fa fa-cogs"></i> Administración de base de datos</h4>
        </template>
        <template slot="modal-body">
            <div class="row">
                <portlet :clase="'container col-md-12 blockui_sample_3_2_element'" > 
                    <template slot="tools">
                        <a href="" class="collapse" data-original-title="" title=""></a>
                    </template>
                    <template slot="caption">
                        <h4><strong>Datos Generales</strong></h4>
                    </template>
                    <template slot="body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="rfc">RFC</label>
                                        <input type="text" name="rfc" id="rfc" class="form-control" placeholder="RFC" v-model="rfc" maxlength="13" @keypress="validaLetrasNumeros($event)"  v-on:input="rfcValida()" autocomplete="off"  :disabled="inputDisable==true" v-on:change="obligaciones()">
                                        <span  class="help-block" style="color:red;">{{ rfc_valid }}</span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="cuenta_estatal">No. de cuenta estatal</label>
                                        <input type="text" name="cuenta_estatal" id="cuenta_estatal" class="form-control" placeholder="No. de cuenta estatal" v-model="cuenta_estatal" maxlength="8"  @keypress="validaNumero($event)" autocomplete="off"  :disabled="inputDisable==true" v-on:change="obligaciones()">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="nombre_razon_social">Nombre o Razón social</label>
                                        <input type="text" class="form-control" name="nombre_razon_social" placeholder="Nombre o Razón social"  v-model="nombre_razon_social"  @keypress="validaLetras($event)" autocomplete="off"  :disabled="true" >
                                        <span class="help-block text-danger" >{{ verifica_obligacion }}</span>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="col-md-12">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="fecha">Año</label>
                                        <input type="text" class="form-control" name="fecha" placeholder="Año"  v-model="fecha" @keypress="validaNumero($event)" autocomplete="off" maxlength="4">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="cantidad_maquinas">Cantidad de máquinas</label>
                                        <input type="text" class="form-control" name="cantidad_maquinas" placeholder="Cantidad de máquinas"  v-model="cantidad_maquinas" maxlength="10" @keypress="validaNumero($event)" autocomplete="off">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <h4><strong>Carga inicial</strong></h4><hr>
                            </div>
                            <div class="col-md-12">
                                <div class="col-md-3">
                                    <div class="md-checkbox-list">
                                        <label for="">Carga inicial a 300 cuotas</label>
                                        <div class="md-checkbox">
                                            <input type="checkbox" id="check_4" class="md-check" disabled checked> 
                                            <label for="check_4">
                                            <span class="inc"></span>
                                            <span class="check"></span>
                                            <span class="box"></span>
                                            opcional </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="md-checkbox-list">
                                        <label for="">Carga inicial a 200 cuotas</label>
                                        <div class="md-checkbox">
                                            <input type="checkbox" id="check_1" class="md-check" v-on:change="check_cuotas()" >
                                            <label for="check_1">
                                            <span class="inc"></span>
                                            <span class="check"></span>
                                            <span class="box"></span>
                                            opcional </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="md-checkbox-list">
                                        <label for="">Prorrateo inicial a 300 cuotas</label>
                                        <div class="md-checkbox">
                                            <input type="checkbox" id="check_3" class="md-check">
                                            <label for="check_3">
                                            <span class="inc"></span>
                                            <span class="check"></span>
                                            <span class="box"></span>
                                            opcional </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3" :hidden="!hidden_input">
                                    <div class="md-checkbox-list">
                                        <label for="">Prorrateo inicial a 200 cuotas</label>
                                        <div class="md-checkbox">
                                            <input type="checkbox" id="check_2" class="md-check" />
                                            <label for="check_2">
                                            <span class="inc"></span>
                                            <span class="check"></span>
                                            <span class="box"></span>
                                            opcional </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <h4><strong>Altas</strong></h4><hr>
                            </div>
                            <div class="col-md-12">
                                 <div class="col-md-4">
                                    <div class="md-checkbox-list">
                                        <label for="">Alta a 300 cuotas</label>
                                        <div class="md-checkbox">
                                            <input type="checkbox" id="check_7" class="md-check" disabled checked> 
                                            <label for="check_7">
                                            <span class="inc"></span>
                                            <span class="check"></span>
                                            <span class="box"></span>
                                            opcional </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4" :hidden="!hidden_input">
                                    <div class="md-checkbox-list">
                                        <label for="">Alta a 200 cuotas</label>
                                        <div class="md-checkbox">
                                            <input type="checkbox" id="check_6" class="md-check" v-on:change="check_cuotas_200()"/>
                                            <label for="check_6">
                                            <span class="inc"></span>
                                            <span class="check"></span>
                                            <span class="box"></span>
                                            opcional </label>
                                        </div>
                                    </div>
                                </div><div class="col-md-4" :hidden="!hidden_input_cuotas">
                                    <div class="md-checkbox-list">
                                        <label for="">Alta a 100 cuotas</label>
                                        <div class="md-checkbox">
                                            <input type="checkbox" id="check_5" class="md-check">
                                            <label for="check_5">
                                            <span class="inc"></span>
                                            <span class="check"></span>
                                            <span class="box"></span>
                                            opcional </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <span class="help-block">&nbsp;</span>
                                <div class="form-group">
                                   <button class="btn blue" v-on:click="updateSaveRegistro()"><i class="fa fa-check"></i> Guardar</button>
                                </div>
                            </div>
                        </div>                            
                    </template>
                </portlet>
            </div>
        </template>
        <template slot="modal-footer">
          <button type="button" data-dismiss="modal" class="btn default" v-on:click="limpiarInputs()">Cerrar</button>
        </template>
      </modal>
      <modalconfirmation :id="'portlet-del'" >      
            <template slot="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true" v-on:click="limpiarInputs()"></button>
                <h4 class="modal-title">Confirmar</h4>
            </template>
            <template slot="modal-body">
               <h5> DETALLE DEL REGISTRO A ELIMINAR:</h5>
                <p><strong>RFC:</strong> {{rfc}}</p>
                <p><strong>Cuenta:</strong> {{cuenta_estatal}}</p>
                <p><strong>Nombre o Razón social:</strong> {{nombre_razon_social}}</p>
                <p><strong>Año:</strong> {{fecha}}</p>
                <p><strong>Cantidad de maquinas:</strong> {{cantidad_maquinas}}</p>
            </template>
            <template slot="modal-footer">
                <button type="button" data-dismiss="modal" class="btn default" v-on:click="limpiarInputs()">Cancelar </button>
                <button type="button" data-dismiss="modal" class="btn green" v-on:click="eliminarRegistro()"><i class="fa fa-check"></i> Aceptar</button>
            </template>
        </modalconfirmation>
    </div>
  </template>  
  <script>
  import axios from 'axios'
  import select2 from './General/Select.vue'
  import portlet from './General/Portlet.vue'
  import modal from './General/Modal.vue'
  import modalconfirmation from './General/ModalConfirmation.vue'
  import tableSample from './Individual/TableMaquinas.vue'
  import VCalendar from 'v-calendar'
  export default {
    name: 'ReporteEstadistica',
    components: {axios,select2,portlet,modal,modalconfirmation,tableSample,VCalendar},
    data(){
        return{
            lengthMenu:[[10, 25, 50, -1],[10, 25, 50, 'All']],
            options:[],
            data_:[],
            id_registro:'',
            rfc:'',
            cuenta_estatal:'',
            nombre_razon_social:'',
            fecha:'',
            cantidad_maquinas:'',
            carga_inicial:0,
            prorrateo_200:0,
            prorrateo_300:0,
            renderTable:false,
            inputDisable:false,
            link_download:`${process.env.APP_URL}/download-maquinas`,
            rfc_valid:'',
            verifica_obligacion:'',
            hidden_input:false,
            hidden_input_cuotas:false,
        }
    },
    methods:{
        handleFileUpload(event){
            this.file = event.target.files[0];
        },
        loadTableSample(){
            this.renderTable = false 
            this.loagingC(true);
            this.data_=[];                  
            axios.get(`${process.env.APP_URL}/find-maquinas`)
                .then((response)=>{
                    this.data_=response.data.response;
                    this.renderTable = true
                    this.loagingC(false);
                })
                .catch(error=>{
                    console.log(error);                    
                    this.loagingC(false);                    
                });
        },
        editarRegistro(dato){
            this.inputDisable=true;
            this.id_registro=dato.id;
            this.rfc=dato.rfc;
            this.cuenta_estatal=dato.cuenta; 
            this.fecha= parseFloat(dato.anio);
            this.nombre_razon_social=dato.nombre_o_razon_social;
            this.cantidad_maquinas=dato.cantidad_de_maquinas;
            let check_1=dato.carga_inicial_a_200 == 0 ? false : true;
            let check_2=dato.prorrateo_a_200 == 0 ? false : true;
            let check_3=dato.prorrateo_a_300 == 0 ? false : true;
            let check_4= true;
            let check_5=dato.altas_a_100 == 0 ? false : true;
            let check_6=dato.altas_a_200 == 0 ? false : true;
            let check_7= true;
            this.$forceUpdate();
            $("#check_1").prop("checked", check_1);
            this.check_cuotas();
            $("#check_2").prop("checked", check_2);
            $("#check_3").prop("checked", check_3);
            $("#check_4").prop("checked", check_4);
            
            $("#check_6").prop("checked", check_6);
            this.check_cuotas_200();
            $("#check_5").prop("checked", check_5);
            $("#check_7").prop("checked", check_7);
           
        },
        nuevoRegistro(){
            this.inputDisable=false;
            this.limpiarInputs();
        },
        check_cuotas(){
            
            if(!$("#check_1").prop("checked")){
                this.hidden_input=false;
            }else{
                this.hidden_input=true;
               
            } 
            $("#check_2").prop("checked", false);
            $("#check_6").prop("checked", false);
            this.check_cuotas_200();
        },
         check_cuotas_200(){
            if(!$("#check_6").prop("checked")){
                this.hidden_input_cuotas=false;
            }else{
                this.hidden_input_cuotas=true;   
            }
            $("#check_5").prop("checked", false);
        },
        limpiarInputs(){
            this.id_registro='';
            this.rfc='';
            this.cuenta_estatal='';
            this.nombre_razon_social='';
            this.fecha='';
            this.cantidad_maquinas='';
            $("#check_1").prop("checked", false);
            $("#check_2").prop("checked", false);
            $("#check_3").prop("checked", false);
            $("#check_4").prop("checked", true);
            $("#check_5").prop("checked", false);
            $("#check_6").prop("checked", false);
            $("#check_7").prop("checked", true);
            this.hidden_input =false;
            this.hidden_input_cuotas =false;
        },
        obligaciones(){
            if(this.id_registro!==""){
                return;
            }
            if(this.rfc.length<12 && this.cuenta_estatal.length<4){
                return;
            }
            this.verifica_obligacion="Consultando...";
            axios.get(`${process.env.APP_URL}/wsapi-obligaciones/${this.rfc}/${this.cuenta_estatal}`)
                .then((response)=>{
                    //this.data_=response.data.response;
                    if(typeof response.data.Message.Data.datosGeneralesInternet.NOMBRE !== "undefined"){
                        this.verifica_obligacion="";
                        this.nombre_razon_social=response.data.Message.Data.datosGeneralesInternet.NOMBRE;
                    }else{
                        this.nombre_razon_social="";
                        this.verifica_obligacion="Consultando...";
                    }
                })
                .catch(error=>{
                    console.log(error);
                    this.verifica_obligacion="Obligaciones no encontradas!";
                    this.nombre_razon_social="";           
                });
        },
        validForm(){
            //this.$forceUpdate();
            //console.log(parseInt(this.fecha));      
            if(!this.rfcValido(this.rfc)){
                this.notifications("400","Formato RFC, requerido!");
                return true;
            }else if(this.cuenta_estatal.length==0){
                this.notifications("400","Cuenta estatal, requerido!");
                return true;
            }else if(this.nombre_razon_social.length==0){
                this.notifications("400","Nombre o Razón social, requerido!");
                return true;
            }else if(this.fecha.length== 0){
                this.notifications("400","Año, requerido!");
                return true;
            }else if(this.cantidad_maquinas.length==0){
                this.notifications("400","Cantidad de máquinas, requerido!");
                return true;
            }else if (parseInt(this.fecha) < 2021 || parseInt(this.fecha) > new Date().getFullYear()-1) {
                this.notifications("400", "Año inválido, 4 dígitos entre 2021 al " + (new Date().getFullYear()-1) );
                return true;
            }
            return false;
        },
        updateSaveRegistro(){
            if(this.validForm()){
                return;
            }
            let c_inicial=$("#check_1").prop("checked") ? true : false;
            let c_inicial_300= true;
            let p_200=$("#check_2").prop("checked") ? true : false;
            let p_300=$("#check_3").prop("checked") ? true : false;
            let a_100=$("#check_5").prop("checked") ? true : false;
            let a_200=$("#check_6").prop("checked") ? true : false;
            let a_300=true;
            axios.post(`${process.env.APP_URL}/insert-update-maquinas`,{
                id: this.id_registro,
                rfc: this.rfc,
                cuenta: this.cuenta_estatal,
                nombre_o_razon_social: this.nombre_razon_social,
                anio: this.fecha,
                cantidad_de_maquinas: this.cantidad_maquinas,
                carga_inicial_a_200: c_inicial,
                carga_inicial_a_300: c_inicial_300,
                prorrateo_a_200: p_200,
                prorrateo_a_300: p_300,
                altas_a_100: a_100,
                altas_a_200: a_200,
                altas_a_300: a_300,
                status:1
                })
                .then((response)=>{
                    this.notifications(response.data.status,response.data.message);
                    this.loadTableSample();
                    if(this.id_registro.length==0){
                        this.limpiarInputs();
                    }
                })
                .catch(error=>{
                    this.notifications("400",error.response.data.message);
                    console.log(error.response);
                }
            );
        },
        eliminarRegistro(){
            axios.post(`${process.env.APP_URL}/delete-maquinas`,{
                id: this.id_registro,
                })
                .then((response)=>{
                    this.notifications(response.data.status,response.data.message);
                    this.loadTableSample();
                    this.limpiarInputs();
                })
                .catch(error=>{
                    console.log(error);
                    
                }
            );
        },

        rfcValida() {
            this.rfc=this.rfc.toUpperCase();
            if(this.rfc.length<12){this.curp_valid=''; return;}
            let vald=this.rfcValido(this.rfc,true);
            if (vald) {
                this.rfc_valid = "";
            } else {
                this.rfc_valid = "Formato incorrecto";
            }
        },
        rfcValido(rfc, aceptarGenerico = true) {
            rfc=rfc.toUpperCase();
            const re =/^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A-Z\d])$/;
            var validado = rfc.match(re);
            if (!validado)
                return false;
            return true;
        },
        validaLetrasNumeros($event){
            if(/[a-zA-Z0-9]/g.test($event.key)){    return true;
            }else{  $event.preventDefault()  } 
        },
        validaLetras($event){
            if(/[A-Za-z ÁÉÍÓÚáéíóúÑñ]/g.test($event.key)){   return true;
            }else{   $event.preventDefault() } 
        },
        validaNumero($event){
            if(/[0-9]/g.test($event.key)){    return true;
            }else{   $event.preventDefault()   } 
        },
        loagingC(value, index, values) {
            return Vue.filter('loadingCharge')(value);
        },
        notifications(Code,Message){
            if(Code=="200"){
                Command: toastr.success(Message, "Notifications");
            }else{
                Command: toastr.warning(Message, "Notifications");
            }
        }
    },
    mounted() {
        this.loadTableSample();
    }
  }
  </script>